import RoundedInput from './RoundedInput'

export default RoundedInput



// WEBPACK FOOTER //
// ./src/app/elements/RoundedInput/index.js